import React from 'react';

import ReactDOM from 'react-dom';

import { Button,Dropdown} from "@jd/find-react";
import {Cascader} from 'element-react';

 

import KeeVue from '../base/KeeVue.js'

import $ from 'jquery';

export default class FsIcon extends KeeVue {
    constructor(props) {
        super(props);

        this.state = {

            isShow: false,
            randId: this.getRandString(),
            id: this.getRandString(),
            targetId: '',
            selectIcons: [],
            selectIconClass: '',
            allUsers: [],
            keyWord: '',
            filterUsers: [],
            iconList: [],
            currentRoleId: '',
            orgList: [],
            reqeustTimes: 0, // 请求次数，自增，用来区分服务器返回的数据
            isSelected: false,
        }

    }

    componentDidMount() {
        var that = this;
        if (this.props.component)
            this.state.targetId = this.props.component.id;
        if (this.props.editable === false || (that.props.form && (that.props.form.editable === false || that.props.form.cp.editable === false))) {
        } else {
            { }
        }
        that.getIcons();
        this.registComponent();
    }

    getIcons = () => {
        var that = this;
        var url = this.props.url;
        if (!url)
            url = "/sysPrivilege/getIconList";
        this.doRequest(url,  (list)=> {
			
			// 在找一下应用自己定义的css库，
			var cssIcons = [{
			"id":"iconfont icon-danhangwenben",	
			},{
			"id":"iconfont icon-duohangwenben",	
			},{
			"id":"iconfont icon-danxuanti",	
			},{
			"id":"iconfont icon-duoxuanti",	
			},{
			"id":"iconfont icon-fenzu",	
			},{
			"id":"iconfont icon-guojiadiqu",	
			},{
			"id":"iconfont icon-jilianxuanxiang",	
			},{
			"id":"iconfont icon-riqi",	
			},{
			"id":"iconfont icon-riqishijian",	
			},{
			"id":"iconfont icon-shengshiqu",	
			},{
			"id":"iconfont icon-shouji",	
			},{
			"id":"iconfont icon-shuzhi",	
			},{
			"id":"iconfont icon-xialadanxuan",	
			},{
			"id":"iconfont icon-xialaduoxuan",	
			},{
			"id":"iconfont icon-youxiang",	
			},{
			"id":"iconfont icon-wenben1",	
			},{
			"id":"iconfont icon-diannan",	
			},{
			"id":"iconfont icon-iphone-icon",	
			},{
			"id":"iconfont icon-app_btn_copy"
			},{
			"id":"iconfont icon-app_ic_delete1"
			},
			
			
			
			,{
			"id":"icon iconfont icondanxuan02"
			},{
			"id":"icon iconfont iconduoxuan02"
			},{
			"id":"icon iconfont iconshurukuang02"
			},{
			"id":"icon iconfont iconxingbie02"
			},{
			"id":"icon iconfont iconxingming02"
			},{
			"id":"icon iconfont iconxialakuang02"
			},{
			"id":"icon iconfont iconshouji02"
			},{
			"id":"icon iconfont icondiqu02"
			},{
			"id":"icon iconfont iconmap-Lined"
			},{
			"id":"icon iconfont iconsave-Lined"
			},{
			"id":"icon iconfont iconCalendar-Lined"
			},{
			"id":"icon iconfont icongroup-Lined"
			},{
			"id":"icon iconfont iconplace-Lined"
			},{
			"id":"icon iconfont iconhome-Lined"
			},{
			"id":"icon iconfont iconshenfenzheng02"
			},{
			"id":"icon iconfont icondownload-Lined"
			},{
			"id":"icon iconfont iconfocus-Lined"
			},{
			"id":"icon iconfont iconnode-Lined"
			},{
			"id":"icon iconfont icontracking"
			},{
			"id":"icon iconfont iconupload-Lined"
			}
			
			];
			 
			 
            that.state.iconList = cssIcons.concat(list);  
			 
            that.state.selectIconClass = this.getValueByAttr(that.props.form, that.field);
            if (this.isNotBlank(that.state.selectIconClass)) {
                that.state.selectIcons = []; // 清空
                that.state.selectIcons.push({
                    id: that.state.selectIconClass
                });
                that.isSelected = true;
            }
            that.setState(that.state);
        });
    }
    del = () => {
        // if (this.state.selectIcons.length === 0) {
        //     return;
        // }
		
		if(this.state.selectIcons.length > 0)
		{
			var item = this.state.selectIcons[0]
			this.state.selectIcons.remove(item);
		}
       
        this.isSelected = false;
        var userIds = "";

        this.setVueAttr(this.props.po, this.props.component.cp.field, "");
        this.props.component.value = "";

        this.setState(this.state);
		this.refresh();
       this.refreshComponent();

    }
    selectIcon = (item) => {
        this.state.selectIconClass = item.id;
        this.state.selectIcons = []; // 清空
        this.state.selectIcons.push(item);
        this.isSelected = true;
        this.setVueAttr(this.props.po, this.props.component.cp.field, this.state.selectIconClass);
        this.props.component.value = item.id;
        // this.setAttr(this.props.component, this.props.component.cp.field, this.state.selectIconClass);
        this.save();
        this.hideMenu();
        this.sendEvent("refresh");
        this.setState(this.state);

        // if (this.props.po && this.props.po.id) {
        //     this.sendEvent(this.props.po.id + ".render");
        // }
		this.refreshComponent();


    }
    showMenu = () => { }
    closeMenu = () => { }
    hideMenu = (randId) => { }
    componentWillReceiveProps = (nextProps) => {

    }
    save = (event) => {
        var that = this;
        var para = {
            id: this.props.component.id
        };
        para[this.props.component.cp.field] = this.getValueByAttr(this.props.component, this.props.component.cp.field);
        if (this.saveUrl) {
            this.doRequest(that.saveUrl,  (ret)=>{
                if (ret.success === true) {
                    if (that.saved) {
                        that.saved();
                    }
                }
                this.changeLog = "";
            }, para)
        }
    }

    render() {
         
		
		      
		       const menu = (
		         <div >
				 <div style={{  background:'#ffffff'}}>
				     <div    style={{
				         bgColor: '#fff',
				         fontWeight: 'normal',
				         zIndex: '9000',
				         height: ' auto',
				         maxHeight: ' 300px',
				         overflow: ' hidden',
				         borderRadius: '0px ',
				         width: '235px',
				         boxShadow: ' 1px 1px 3px rgba(0,0,0,0.3)'
				     }}>
				         <div style={{width: ' 100%', height: ' 98%', overflow: 'hidden'}}>
				             <div style={{height: ' 36px', background: ' #FFFFFF', opacity: ' 1'}}>
				                 <div style={{
				                     width: ' 100%',
				                     height: ' 100%',
									 padding:'5px',
				                     borderBottom: ' 1px solid #CCCCCC'
				                 }}>
				                     <Button size="small" type="danger" onClick={this.del}>
				                         清除
				                     </Button>
				                     <div style={{'float': 'right'}}>
				                         <Button size="small" type="danger" onClick={this.hideMenu}>
				                             <i className={`el-icon-close`}></i>
				                         </Button>
				                     </div>
				                 </div>
				 
				             </div>
				             <div style={{maxHeight: ' 250px', overflow: ' auto', width: '100%'}}>
				                 {
				                     this.state.iconList.map((item, index) => {
				                         // if (item.id.indexOf("iconfont ") == 0) {
				                         //     return "";
				                         // }
				                         return <div rowid={item.id} key={item.id + index}
				                                     className={`kee-icon-item ${item.id === this.props.component.value ? 'kee-icon-selected' : ''}`}
				                                     style={{
				                                         width: ' 40px',
				                                         height: ' 40px',
				                                         padding: '0px 7px',
				                                         fontSize: '26px ',
														 display:'inline-block',
				                                          
				                                     }}>
				                             <span className={`${item.id}`} title={item.id}
				                                   style={{cursor: ' pointer'}}
				                                   onClick={() => this.selectIcon(item)}></span>
				                         </div>
				                     })
				                 }
				 
				             </div>
				         </div>
				     </div>
				 </div>
		         </div>
		       );
		       const dropIconList =  (
			   <div style={{background: ' #FFFFFF'}}>
		         <Dropdown
		           overlay={menu}
		            placement="bottomCenter"
					trigger={['click']}
		         >
				 
		           {
		                           this.props.component.value  ?
		                               <i  className={this.props.component.value}
		                                     title={this.props.component.value}
		                                     style={{cursor: ' pointer',marginTop:'10px', fontSize: ' 26px'}}>
											 
		           </i>
		                               :
		                               <div >
		                                   <Button size="small" type="primary"  >
		                                       设置图标
		                                   </Button>
		                               </div>
		                       }
		         </Dropdown>
				</div>
		       );
		     
		

          return   <div style={{ width: ' 100%', fontWeight: ' normal'}} id={this.state.randId}> 
                {
                    (this.props.editable === false || (this.props.component && (this.props.component.editable === false || this.props.component.cp.editable === false))) ?
                        <i className={this.props.component.value}> 
					</i>
                        :
                        dropIconList
                }

            </div>
        
    }
}
